module.exports = __webpack_public_path__ + "img/eonlife_logo_1.4adee176.png";